/* eslint-disable @typescript-eslint/no-explicit-any */
import { ParsedUrlQuery } from 'querystring'

import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next'
import { NextRouter } from 'next/router'

import { LOCALE } from './Locale'

type ExtendingNextRouter = {
  locale: LOCALE
}

export type ExtendedNextRouter = NextRouter & ExtendingNextRouter

export type ExtendedContextType<
  Q extends ParsedUrlQuery = ParsedUrlQuery
> = GetServerSidePropsContext<Q> & {
  locale: LOCALE
  locales: LOCALE[]
}

export type ExtendedGetServerSideProps<
  P extends { [key: string]: any } = { [key: string]: any },
  Q extends ParsedUrlQuery = ParsedUrlQuery
> = (context: ExtendedContextType<Q>) => Promise<GetServerSidePropsResult<P>>

export type TranslateOption = {
  value: string
  label: string
}

export type SiteWideBannerApi = {
  content: string
  icon: string
  link: string
  sitewide_type: 'icon-text' | 'banner'
  banner_desktop?: string
  banner_mobile?: string
  background_color?: string
  banner_display_frequency?: string
}

export type Frequency = 'daily' | 'weekly' | 'bi-weekly'

export type SiteWideBanner = {
  content: string
  icon: string
  link: string
  type: 'article' | 'category' | 'home' | 'other'
  layoutType: 'icon-text' | 'banner'
  bannerDesktop: string
  bannerMobile: string
  backgroundColor: string
  bannerDisplayFrequency: Frequency
}
export type SearchQuery = {
  s: string
  // date: string
  // category_id: string | number
  page: string | number
}

export type AmpOn = {
  like: string
  dislike: string
}

export enum FeedbackType {
  LIKE = 1,
  UNLIKE,
}

export enum ReactionType {
  DisLike,
  Like,
  None,
}

export type FooterLink = {
  title: string
  link: string
}

export type DropdownOption<V> = {
  label: string
  value: V
}

export type BannerItem = {
  desktop?: string
  mobile?: string
}

export type BannerSection = {
  heading?: string
  description?: string
  ctaUrl?: string
  ctaTitle?: string
  banner?: {
    desktop?: string
    mobile?: string
  }
}

export type RedirectionType = {
  redirect_url?: string
  status_code?: 301 | 302 | 303 | 307 | 308 | 404
  source_flags?: {
    flag_query?: string
  }
}
